<template>
  <div class="page">
    <div class="page__text fs4 mv4">
      <p>
        異常訊息:
        <span v-if="page === 'death'"> {{ message }} </span>
        <span v-else> page ({{ page }}) 名稱錯誤 </span>
      </p>
    </div>
    <div class="page__text">
      抱歉發生異常，請截圖與我們聯繫，造成不便還請見諒。
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '無錯誤訊息',
    },
    page: {
      type: String,
      default: '',
    },
  },
};
</script>
